<template>
  <div class="question-con">
    <div class="current">
      <span class="big-span">{{current+1}}</span>
      <span>/10</span>
    </div>
    <swiper :options="swiperOption" class="swiper-con" ref="mySwiper" @init="onInit()">
      <!-- slides -->
      <swiper-slide class="slide-item" v-for="(item,index) in question_arr" :key="index">
        <!-- 学生图片 -->
        <div class="item-con">
          <div
            class="student-pic"
            :style="{width:item.width,height:item.height,backgroundImage: item.image}"
          ></div>
          <div class="qusetion-title">{{item.title}}</div>
          <div class="answers-con">
            <div
              class="answer-item"
              :class="{'change-color': answer_index == now_index}"
              v-for="(answer_item,answer_index) in item.answers"
              :key="answer_index"
              :data-point="answer_item.point"
              @click="selectAnswer(index,answer_item.point,answer_index)"
            ><span class="options">{{answer_index == 0?'A.':answer_index == 1? 'B.':answer_index == 2?'C.':'D.'}}</span><span class="options-item">{{answer_item.item}}</span></div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: "carrousel",
  data() {
    return {
      totol: [],
      current: 0,
      now_index: -1,
      question_arr: [
        {
          title:
            "漫长的假期过后，终于开学了～穿过校园，走进班级，站在孩子们面前，你感觉：",
          image: "url(" + require("../assets/images/pic1.png") + ")",
          width: "6.33rem",
          height: "4.07rem",
          answers: [
             {
              item: "又是和淘气包们斗智斗勇的一学期……",
              point: "3"
             },
             {
              item: "过了个年，孩子们都胖了。",
              point: "4"
            },
            {
              item: "幸福无比，又见到这些小可爱了！",
              point: "5"
            },
            {
              item: "我想回家！",
              point: "2"
            },
          ]
        },
        {
          title:
            "过年了，多年没见的二姨远道而来，听说你在乡村做教师，二姨很担心地说：“在乡村太辛苦了，快换份工作吧！”听到这个你会说：",
          image: "url(" + require("../assets/images/pic2.png") + ")",
          width: "5.82rem",
          height: "3.6rem",
          answers: [
            {
              item: "辛苦是辛苦一些，走一步看一步吧。",
              point: "3"
            },
             {
              item: "二姨，我也是这样想的！",
              point: "2"
            },
            {
              item:
                "二姨，听说你家孩子在读师范，实习的时候可以到乡村学校去体验一下。",
              point: "5"
            },
            {
              item: "每天和孩子们在一起，感觉自己越活越年轻了。",
              point: "4"
            },
           
           
          ]
        },
        {
          title: "对于从事乡村教育，哪一项最像你的选择？",
          image: "url(" + require("../assets/images/pic3.png") + ")",
          width: "4.67rem",
          height: "4.84rem",
          answers: [
            {
              item: "乡村教师是我的工作，我要对得起这份工作。",
              point: "4"
            },
            {
              item: "边做边看。",
              point: "2"
            },
            {
              item: "虽然内心偶有摇摆，但我仍能无微不至地陪伴孩子。",
              point: "3"
            },
            {
              item: "一直坚信乡村教育的价值，我能干一辈子。",
              point: "5"
            },
          ]
        },
        {
          title: "哪一项最像你此时的状态？",
          image: "url(" + require("../assets/images/pic4.png") + ")",
          width: "5.71rem",
          height: "4.38rem",
          answers: [
            {
              item:
                "我可能不是太阳，但也能发出光，带动更多的人相信乡村教育的价值。",
              point: "5"
            },
            {
              item: "能力虽然有限，但能帮一个孩子是一个。",
              point: "2"
            },
            {
              item:
                "乡村孩子目前可能和城市孩子在教育资源上有差距，但我对他们充满信心！",
              point: "4"
            },
            {
              item: "对乡村教育有愿景，也有一定的工作计划。",
              point: "3"
            },
          ]
        },
        {
          title: "你会倾向于以下哪一种课堂氛围？",
          image: "url(" + require("../assets/images/pic5.png") + ")",
          width: "6rem",
          height: "4.23rem",
          answers: [
            {
              item: "自由而随意",
              point: "2"
            },
             {
              item: "生动且活泼",
              point: "5"
            },
            {
              item: "严谨且高压",
              point: "3"
            },
            {
              item: "平稳而有序",
              point: "4"
            },
          ]
        },
        {
          title:
            "阿华是一位闻名全校的六年级“问题学生”，每天他只想着下课打球、回家玩游戏，成绩一退再退，作为他的新班主任，你会如何做？",
          image: "url(" + require("../assets/images/pic6.png") + ")",
          width: "5.33rem",
          height: "4.01rem",
          answers: [
             {
              item: "利用班会课组织一场篮球比赛，赛后鼓励阿华的场上表现。",
              point: "5"
            },
            {
              item:
                "告诉全班六年级是个关键时期，升学考试非常重要，兴趣爱好先放一放。",
              point: "2"
            },
            {
              item: "通知家长严格管控阿华玩游戏并监管其学习。",
              point: "3"
            },
            {
              item: "与前任班主任、科任教师了解阿华情况，开导阿华重视学习。",
              point: "4"
            },
          ]
        },
        {
          title: "作为教师，你会倾向以什么样的方式传播你的教育经验？ ",
          image: "url(" + require("../assets/images/pic7.png") + ")",
          width: "5.96rem",
          height: "4.48rem",
          answers: [
            {
              item: "在朋友圈分享",
              point: "4"
            },
            {
              item: "专注于课堂",
              point: "2"
            },
            {
              item: "向家长说明",
              point: "3"
            },
            {
              item: "和同事分享交流",
              point: "5"
            }
          ]
        },
        {
          title:
            "阿芳是一位品学兼优的好学生，但是她人缘不好，被孤立，你会如何做？",
          image: "url(" + require("../assets/images/pic8.png") + ")",
          width: "4.92rem",
          height: "4.6rem",
          answers: [
             {
              item: "找出原因，处理各方情绪，组织促进凝聚力活动，使班级一心。",
              point: "5"
            },
            {
              item: "找出阿芳被孤立的原因，主动帮她解决，让她担任班长。",
              point: "2"
            },
            {
              item: "组织团建活动，让阿芳被其他伙伴接受，能跟同学玩在一起。",
              point: "4"
            },
            {
              item: "了解阿芳的学习习惯，听取同学、家长的意见，充分沟通。",
              point: "3"
            },
           
          ]
        },
        {
          title: "如果有5天可以随意支配，你会如何度过呢？",
          image: "url(" + require("../assets/images/pic9.png") + ")",
          width: "3.74rem",
          height: "4.66rem",
          answers: [
            {
              item: "回家陪陪父母、爱人和孩子，为自己的生活充充电。",
              point: "幸福"
            },
            {
              item: "参加培训，提升教育教学能力，期待为学生提供更好的教育。",
              point: "信念"
            },
            {
              item:
                "静下心来整理自己的教育经验，向外分享，帮助更多人一起进步。",
              point: "影响"
            },
            {
              item:
                "和班级中最需要关心的学生一起做有趣的活动，爱就趁这个机会表达。",
              point: "智慧"
            },
          ]
        },
        {
          title: "如果有3万元的资金可以随意支配，你会如何使用呢？",
          image: "url(" + require("../assets/images/pic10.png") + ")",
          width: "4.6rem",
          height: "4.62rem",
          answers: [
            {
              item: "组织家长、社区与学校的互动活动，赢得更多理解与支持。",
              point: "影响"
            },
            {
              item: "引进创新型教学设备，让乡村学生也能拥有开阔的视野。",
              point: "智慧"
            },
            {
              item: "帮助留守、单亲的孩子，缺失的爱也需要被弥补。",
              point: "幸福"
            },
            {
              item: "参与外出游学，去看看外面的教育理念和方式。",
              point: "信念"
            }
          ]
        }
      ],
      swiperOption: {
        direction: "vertical",
        updateOnImagesReady: true,
        on: {
          init: function() {
            //Swiper初始化了
            this.emit("transitionEnd"); //在初始化时触发一次transitionEnd事件，需要先设置transitionEnd
          },
          slideChangeTransitionStart: () => {
            let index = this.swiper.activeIndex;
            this.current = index;
            if (index == 0) {
            }
            if (index == 1) {
            }
            if (index == 2) {
            }
            if (index == 3) {
            }
            if (index == 4) {
            }

            if (index == 5) {
            }

            if (index == 6) {
            }

            if (index == 7) {
            }

            if (index == 8) {
            }

            if (index == 9) {
            }

            if (index == 10) {
            }
          }
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    selectAnswer(index, point, answer_index) {
      this.totol[index] = point;
      this.now_index = answer_index;
      if (this.swiper.isEnd) {
        let total = this.totol;
        let xf = total[0] * 1 + total[1] * 1;
        let xn = total[2] * 1 + total[3] * 1;
        let zh = total[4] * 1 + total[5] * 1;
        let yx = total[6] * 1 + total[7] * 1;
        if (total[8] == "幸福") {
          xf += 5;
        } else if (total[8] == "信念") {
          xn += 5;
        } else if (total[8] == "智慧") {
          zh += 5;
        } else if (total[8] == "影响") {
          yx += 5;
        }

        if (total[9] == "幸福") {
          xf += 5;
        } else if (total[9] == "信念") {
          xn += 5;
        } else if (total[9] == "智慧") {
          zh += 5;
        } else if (total[9] == "影响") {
          yx += 5;
        }
        let max = Math.max(xf, xn, zh, yx);
        let result = null;
        let typeName = null;
        if (max == xf) {
          result = "xf";
          typeName = "幸福型";
        } else if (max == xn) {
          result = "xn";
          typeName = "信念型";
        } else if (max == zh) {
          result = "zh";
          typeName = "智慧型";
        } else if (max == yx) {
          result = "yx";
          typeName = "影响型";
        }
        console.log(result);
        let username = sessionStorage.getItem("name");

        $.ajax({
          type: "POST",
          url: "https://m.xiaoxxx.com/h5/publicWelfare/api/create",
          data: {
            username: username,
            typeName: typeName
          },
          dataType: "json",
          success: function(res) {
          }
        });
        setTimeout(() => {
          this.$router.push({
            path: "/Result",
            query: {
              result: result
            }
          });
        }, 1000);
      } else {
        setTimeout(() => {
          this.current += 1;
          this.swiper.slideTo(index + 1, 500, false);
          this.now_index = -1;
          let figureImgUrl = this.figureImgUrl;
        }, 1000);
      }
    }
  },
  mounted() {
  }
};
</script>

<style>
.question-con {
  width: 100%;
  height: 100vh;
  /* overflow: hidden; */
}
.swiper-con {
  width: 100%;
  height: 100% !important;
  font-size: 0.32rem;
}
.slide-item {
  position: relative;
  box-sizing: border-box;
  padding: 0 0.4rem;
  width: 100%;
  height: 100% !important;
  background-image: url("../assets/images/canvas-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
}
.item-con {
  position: absolute;
  width: 6.7rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.qusetion-title {
  font-size: 0.32rem;
  font-weight: 600;
}
.answers-con {
  margin-top: 0.34rem;
}
.answer-item {
  box-sizing: border-box;
  padding: 0.15rem 0.1rem;
  border: 2px solid #acacac;
  border-radius: 5px;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  font-weight: 600;
}
.student-pic {
  /* width: 6.33rem;
  height: 4.07rem; */
  margin: 0 auto;
  /* margin-top: 0.2rem; */
  margin-bottom: 0.3rem;
  /* background-image: url("../assets/images/pic1.png"); */
  background-size: cover;
  background-repeat: no-repeat;
}
.change-color {
  /* color: #ff6100; */
  /* border: 1px solid #E6E6FA ; */
  animation: white-click 0.6s ease-out forwards;
}
.show_white {
  position: fixed;
  width: 7.5rem;
  height: 100vh;
  /* background: #fff; */
  z-index: 999;
}
.current {
  position: fixed;
  left: 0.48rem;
  top: 0.2rem;
  width: 0.85rem;
  height: 0.48rem;
  line-height: 0.48rem;
  border-radius: 0.24rem;
  background: rgba(0, 0, 0, 0.3);
  /* opacity: 0.3; */
  z-index: 50;
  color: #fff;
  font-size: 0.16rem;
  text-align: center;
}
.current span {
  opacity: 1;
}
.big-span {
  font-size: 0.32rem;
}
.options {
  display: inline-block;
  width: 5%;
  vertical-align: top;
}
.options-item {
  display: inline-block;
  width: 95%;
}
@keyframes white-click {
  from {
    background: #fff;
    opacity: 0;
  }
  to {
    background: #FF7200;
    opacity: 0.6;
    color: #fff;
    border: 2px solid #FF7200;
  }
}
</style>